export default __webpack_public_path__ + "static/media/aeroland-macbook-03.8478e393.png";